import { render } from "./DocumentDialog.vue?vue&type=template&id=80a4a1c0&scoped=true"
import script from "./DocumentDialog.vue?vue&type=script&lang=js"
export * from "./DocumentDialog.vue?vue&type=script&lang=js"

import "./DocumentDialog.vue?vue&type=style&index=0&id=80a4a1c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a4a1c0"]])

export default __exports__